module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAABGdBTUEAALGPC/xhBQAAAIlJREFUGBlj6F60iHvmzFX8DESAvukLpZn+f/oZ9/H3p12ENHVPnd3w99+vVYwgg7umzulj+M9gzc/K55aeHvYR3TKQ4v8MDCGMTOxOYA34NCErLs2MewXXgE0TumKQGhQNyJqYGBn3/WP45wtyBshkkBwIYGgACXZPmdP7n+G/KyMzuwuyYpAcAM80Ri2B1x+tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/assets/Left_Chevron_Circle-path.png
// module id = ./src/layouts/PageLayout/assets/Left_Chevron_Circle-path.png
// module chunks = 1